import { render, staticRenderFns } from "./AiChat.vue?vue&type=template&id=77146083&scoped=true"
import script from "./AiChat.vue?vue&type=script&lang=js"
export * from "./AiChat.vue?vue&type=script&lang=js"
import style0 from "./AiChat.vue?vue&type=style&index=0&id=77146083&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77146083",
  null
  
)

export default component.exports